import React, { useState } from "react";
import { Col, Row, Container, Card, Form, FormControl } from "react-bootstrap";
import { products } from "../../data/products_data";
import Product from "./product";
import "./products.css";
const Products = ({ history }) => {
  const [prods, setProds] = useState(products);
  const [search, setSearch] = useState("");
  const [accessDetails, setAccessDetails] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [selectedTitle, setSelectedTitle] = useState("");
  const [selectedText, setSelectedText] = useState("");
  const [selectedImg, setSelectedImg] = useState("");
  return (
    <div>
      <Container>
        <Row lg={12} style={{ marginLeft: "20px" }}>
          <Form inline style={{ marginTop: "20px" }}>
            <div style={{ color: "green", margin: "10px", fontSize: "40" }}>
              {" "}
              SEARCH PRODUCTS YOU WANT:
            </div>
            <FormControl
              type="text"
              placeholder="Search Products You Want"
              className="mr-sm-2"
              value={search}
              onChange={(e) => {
                const selectedProducts = products.filter((p) => {
                  return p.title
                    .toLowerCase()
                    .includes(e.target.value.toLowerCase());
                });
                setProds(selectedProducts);
                setSearch(e.target.value);
              }}
              style={{ width: "300px" }}
            />
          </Form>
        </Row>

        {accessDetails === false ? (
          <Row>
            {prods.map((p) => {
              return (
                <>
                  <Col key={p.id} xs={12} md={6} lg={4}>
                    <Card
                      className="card_style"
                      style={{ width: "18rem", margin: "10px" }}
                      onClick={() => {
                        setAccessDetails(!accessDetails);
                        setSelectedId(p.id);
                        setSelectedTitle(p.title);
                        setSelectedText(p.text);
                        setSelectedImg(p.img);
                        history.push(`/products/${p.id}`);
                      }}
                    >
                      <Card.Img
                        variant="top"
                        src={p.img}
                        style={{ height: "200px" }}
                      />

                      <Card.Body>
                        <Card.Title>{p.title}</Card.Title>
                      </Card.Body>
                    </Card>
                  </Col>
                </>
              );
            })}
          </Row>
        ) : (
          <>
            <Product
              selectedId={selectedId}
              selectedTitle={selectedTitle}
              selectedText={selectedText}
              selectedImg={selectedImg}
            />
          </>
        )}
      </Container>
    </div>
  );
};

export default Products;
